import { FiAlertTriangle } from 'react-icons/fi';

export function ReportError() {
  return (
    <div
      className="flex w-full gap-4 p-4 rounded-lg bg-danger-300/10 border-solid border
        border-danger-300"
    >
      <FiAlertTriangle className="w-12 h-12 text-danger-300" />
      <div className="flex flex-col justify-center flex-grow gap-1.5">
        <p className="text-sm font-bold text-neutral-500">
          Não foi possível gerar o relatório no momento
        </p>

        <p className="text-xs text-neutral-500">
          Aguarde uns minutos e tente novamente. Se o problema persistir, entre
          em contato com o suporte.
        </p>
      </div>
    </div>
  );
}
